enum ErrorCode {
    NoError = 0,
    Exception = 1,
    Undefined = 2,
    //============<< User >>============
    DuplicateUser = 101,
    CreateUserProblem = 102,
    //NoExistUserName = 103,
    NoExistUser = 104,
    WrongPassword = 105,
    InvalidToken = 106,
    MobileNotConfirmed = 107,
    SmsAlreadySent = 108,
    InvalidVerificationCode = 109,
    RemovePasswordFailed = 110,
    AddPasswordFailed = 111,
    ChangePasswordFailed = 112,
    BigProfilePicture = 113,
    InvalidImageExtention = 114,
    InvalidSMSTemplate = 115,
    UserIsBlocked = 116,
    //============<< Cart >>============
    InvalidGiftCode = 201,
    NoItemsInCart = 202,
    ConflictCart = 409,
    //============<< Order >>============
    InvalidOrderIdOrUserId = 301,
    TrackingNotInAdminConfirmedStatus = 302,
    TrackingNotInSentStatus = 303


}

export const errorCodeMessage = (errorCode: ErrorCode) => {
    switch (errorCode) {
        case ErrorCode.Exception:
        case ErrorCode.Undefined:
            return (`خطای داخلی سرور: مشکلی پیش آمده است. لطفا با ما تماس بگیرید.`);
        case ErrorCode.DuplicateUser:
            return ("این نام کاربری تکراری است.")
        case ErrorCode.CreateUserProblem:
            return ("مشکلی در ساخت کاربر به وجود آمد.")
        case ErrorCode.SmsAlreadySent:
            return ("لطفا برای کد تایید چند دقیقه دیگر تلاش کنید.")
        case ErrorCode.NoExistUser:
            return ("این نام کاربری وجود ندارد.")
        case ErrorCode.WrongPassword:
            return ("پسورد اشتباه است.")
        case ErrorCode.InvalidGiftCode:
            return ("کد هدیه نامعتبر است")
        case ErrorCode.InvalidVerificationCode:
            return ("کد وارد شده نا معتبر است")
        case ErrorCode.MobileNotConfirmed:
            return ("شما شماره موبایل خود را تایید نکرده‌اید. لطفا دوباره اقدام به ثبت نام کنيد.")
        case ErrorCode.NoItemsInCart:
            return ("سبد خرید شما خالی است.")
        case ErrorCode.InvalidOrderIdOrUserId:
            return ("شماره سفارش یا شماره کاربری نامعتبر است.")
        case ErrorCode.TrackingNotInAdminConfirmedStatus:
            return ("شماره پیگیری نامعتبر است.")
        case ErrorCode.TrackingNotInSentStatus:
            return ("شماره پیگیری نامعتبر است.")
        case ErrorCode.InvalidToken:
            return ("توکن نامعتبر است.")
        case ErrorCode.RemovePasswordFailed:
            return ("حذف رمز عبور با مشکل مواجه شد.")
        case ErrorCode.AddPasswordFailed:
            return ("اضافه کردن رمزعبور با مشکل مواجه شد.")
        case ErrorCode.ChangePasswordFailed:
            return ("تغییر رمزعبور با مشکل مواجه شد.")
        case ErrorCode.BigProfilePicture:
            return ("حجم عکس بیش از حد مجاز است.")
        case ErrorCode.InvalidImageExtention:
            return ("فرمت عکس نامعتبر است.")
        case ErrorCode.InvalidSMSTemplate:
            return ("قالب پیامک نامعتبر است.")
        case ErrorCode.ConflictCart:
            return ("وضعیت سفارشات قبلی هنوز اتمام نشده است")
        case ErrorCode.UserIsBlocked:
            return ("حساب کاربری شما مسدود شده است. برای اطلاعات بیشتر تماس بگیرید.")

        default:
            if (errorCode)
            return (`خطای ناشناخته کد ${errorCode}`)
            else return "خطای ناشناخته"
    }
}
export default ErrorCode